import createRoute    from '@widesk-ui/tools/createRoute';
import AdminUserModel from '@models/admin/AdminUserModel';

export default createRoute.table('/admin_users', 'admin', 'AdminUserTable', AdminUserModel.localize('plural'));